import { render, staticRenderFns } from "./crearpromo.vue?vue&type=template&id=c881639c&scoped=true&"
import script from "./crearpromo.vue?vue&type=script&lang=js&"
export * from "./crearpromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c881639c",
  null
  
)

export default component.exports